import axios from 'axios';
import { getKeycloakToken } from './keycloak';

// Relative path works in Docker (frontend Nginx proxies /api to backend) and behind host Nginx.
const API_BASE_URL =
  process.env.REACT_APP_API_GATEWAY_URL ||
  process.env.REACT_APP_API_URL ||
  '/api';

const httpClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 25000,
  headers: {
    'Content-Type': 'application/json',
  },
});

const TENANT_STORAGE_KEY = 'activeTenantId';
const ACTIVE_PERSONA_STORAGE_KEY = 'activePersona';

httpClient.interceptors.request.use(async (config) => {
  // SSO only: always send the (auto-refreshed) Keycloak access token.
  const token = await getKeycloakToken();
  if (token) {
    localStorage.setItem('authToken', token);
    config.headers.Authorization = `Bearer ${token}`;
  }

  // Attach tenant context if one is active. The backend treats this header
  // as authoritative and will reject requests whose X-Tenant-Id does not
  // match one of the caller's memberships.
  try {
    const activeTenantId = localStorage.getItem(TENANT_STORAGE_KEY);
    if (activeTenantId) {
      config.headers['X-Tenant-Id'] = activeTenantId;
    }
  } catch {
    // localStorage unavailable — skip tenant header.
  }

  // The persona the user is acting as (a role they hold). The backend only
  // ever narrows access with it and ignores a value that is not theirs.
  try {
    const activePersona = localStorage.getItem(ACTIVE_PERSONA_STORAGE_KEY);
    if (activePersona) {
      config.headers['X-Active-Persona'] = activePersona;
    }
  } catch {
    // localStorage unavailable — skip persona header.
  }

  return config;
});

httpClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const message =
      error?.response?.data?.error ||
      error?.message ||
      'Request failed';
    return Promise.reject(new Error(message));
  }
);

export default httpClient;

